import { api } from "./useApi";

export type DropshippingSincronizacao = {
  situacao: "ok" | "sincronizando" | "parado" | "erro";
  motivo?: string;
  total?: number;
  copiados?: number;
  pendentes?: number;
  removidos?: number;
  estoques_atualizados?: number;
  erros?: string[];
  data: string;
} | null;

export type DropshippingChave = {
  id: number;
  nome: string;
  chave: string;
  id_catalogo: number;
  catalogo: string | null;
  empresa_satelite: string | null;
  data_criacao: string;
  data_vinculo: string | null;
  ultima_sincronizacao: string | null;
  sincronizacao_info: DropshippingSincronizacao;
};

export type DropshippingVinculo = {
  id: number;
  nome: string;
  ativo: boolean;
  empresa_mae: string;
  catalogo: string | null;
  data_vinculo: string;
  data_remocao: string | null;
  ultima_sincronizacao: string | null;
  sincronizacao_info: DropshippingSincronizacao;
  total_produtos: number;
};

export type DropshippingConfiguracao = {
  mae: {
    catalogos: { id: number; descricao: string; tabela: string }[];
    chaves: DropshippingChave[];
  } | null;
  satelite: {
    vinculo: DropshippingVinculo | null;
  } | null;
};

export const dropshippingApi = () => ({
  configuracao: async (): Promise<DropshippingConfiguracao> => {
    const res = await api.post("dropshipping/configuracao");
    return res.data;
  },
  criarChave: async (nome: string, id_catalogo: number) => {
    const res = await api.post("dropshipping/criar_chave", { nome, id_catalogo });
    return res.data as { id: number; chave: string };
  },
  editarChave: async (id: number, nome: string, id_catalogo: number) => {
    const res = await api.post("dropshipping/editar_chave", { id, nome, id_catalogo });
    return res.data;
  },
  removerChave: async (id: number) => {
    const res = await api.post("dropshipping/remover_chave", { id });
    return res.data;
  },
  vincular: async (chave: string) => {
    const res = await api.post("dropshipping/vincular", { chave });
    return res.data as { empresa_mae: string; catalogo: string };
  },
});
